"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of the external DashboardContent namespace.
 * This does not follow the Impl pattern as DashboardContent is
 * currently just a (single) property bag.
 */
class DashboardContent {
    constructor(_dashboard) {
        this._dashboard = _dashboard;
    }
    get dashboard() {
        return this._dashboard;
    }
}
exports.DashboardContent = DashboardContent;
//# sourceMappingURL=DashboardContent.js.map